import API from "./api";
import toast from "react-hot-toast";

/* ================================
   GET EMPLOYEE DETAILS
================================ */
export const getEmployeeById = async (id) => {
  try {
    const res = await API.get(`/register/${id}`);
    return res.data?.employee || res.data || null;
  } catch (error) {
    toast.error("Failed to fetch employee ❌");
    return null;
  }
};

/* ================================
   UPLOAD DOCUMENTS
================================ */
export const uploadEmployeeDocuments = async (id, formData) => {
  try {
    const res = await API.post(`/documents/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    toast.success(res.data?.message || "Uploaded Successfully ✅");
    return res.data;

  } catch (error) {
    toast.error(error?.response?.data?.message || "Upload Failed ❌");
    throw error;
  }
};

/* ================================
   GET DOCUMENTS
================================ */
export const getEmployeeDocuments = async (id) => {
  try {
    const res = await API.get(`/documents/${id}`);


    return res; // ✅ RETURN FULL RESPONSE (IMPORTANT)

  } catch (error) {
    throw error;
  }
};